class Dialog {
    constructor(el, settings) {
        this.DOM = {
            el
        };

        this.default = {};
        this.open = false;

        this.settings = Object.assign(this.default, settings);

        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('scroll', () => {
            if (!this.open) {
                document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
            }
        });
    }

    show() {
        this.DOM.el.classList.add('show');
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        const body = document.body;
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}`;
    }

    close() {
        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
        this.DOM.el.classList.remove('show');
    }
}
